import React from 'react'
import LineChart from 'src/blades/lineChart';
import numberFormatter from 'src/utils/numberFormatter';
import { numberFormat } from 'highcharts';
import NoData from '../shared/noDataComponent';
import Loader from '../loader.component';
const chartProps = {
    type: "column",
    backgroundColor: "Transparent",
    height: 400,
    marginBottom: 100,
    marginTop: 30,
    style: {
        fontFamily: "Segoe UI",
    }
};
const otherOptions = {
    title: {
        text: '',
    },
    tooltip: {
        formatter: function () {
            const { number: value, suffix = '' } = numberFormatter(this.y)
            return `${this.series.name}: <b>$${numberFormat(value, 2, '.', ',')}${suffix}</b>`;
        }
    },
    xAxis: {
        type: 'category',
        labels: {
            rotation: -45,
            formatter: function () {
                const text = this.value,
                    formatted = text.length > 15 ? text.substring(0, 12) + '...' : text;

                return '<div title="' + text + '">' + formatted + '</div>';
            },
            useHTML: true,
            style: {
                color: '#FFFFFF'
            }
        }
    },
    yAxis: {
        title: {
            text: 'USD'
        },
        labels: {
            style: {
                color: '#FFFFFF'
            },
            formatter: function () {
                const { number: value, suffix = '' } = numberFormatter(this.value)
                return `${numberFormat(value, 2, '.', ',')}${suffix}`;
            }
        }
    },
    lang: {
        thousandsSep: ',' // Set comma as the thousands separator
    },
    credits: {
        enabled: false
    },
}

const AnalyticsLineGraph = ({ seriesData,loader}) => {
    const isSeriesDataValid = (typeof seriesData === 'string' || !seriesData);
    return (
        <div className="App">
            {loader && <Loader />} 
                <h3 className='text-light-addonColor text-lg font-sans font-semibold'> {!isSeriesDataValid ? seriesData.heading : 'Analytics Data'}</h3>
            {!isSeriesDataValid && !loader &&  <LineChart
                shouldFetch={false}
                chartProperties={chartProps}
                seriesKey="experienceChart"
                otherOptions={otherOptions}
                axiskey={'yAxis'}
                hasFetchParams={true}
                seriesData={seriesData}
            />}
            {isSeriesDataValid && <div className="chart-nodata"><span><NoData /></span></div>}
        </div>
    );
}

export default React.memo(AnalyticsLineGraph)
